import Container from 'react-bootstrap/Container'

import Typography from '../../components/Typography/Typography'
import ErrorWindow from '../../components/Windows/ErrorWindow/ErrorWindow'

import { useIntl } from 'react-intl'
import './Page500.scss'

const Page500 = () => {
    const intl = useIntl()

    const backToCinestarWeb = () => {
        let referer = localStorage.getItem('referer')
        if (!referer || referer === 'undefined') {
            referer = `https://${process.env.REACT_APP_WEB_PORTAL_URL}`
        }
        window.location.href = referer
    }
    return (
        <Container fluid className="page-500 d-flex flex-column align-items-center">
            <Typography variant={'h1'} className={'me-auto'}>
                {intl.formatMessage({ id: 'page500.pageTitle' })}
            </Typography>
            <ErrorWindow
                title={intl.formatMessage({ id: 'page500.title' })}
                description={intl.formatMessage({ id: 'page500.description' })}
                textButton1={intl.formatMessage({ id: 'page500.button' })}
                onClickButton1={() => backToCinestarWeb()}
            />
        </Container>
    )
}

export default Page500
